import { useCallback, useContext, useMemo } from "react";
import { AccrualImporterContext } from "./accrualImporter.context";
import { AccrualImporterDocumentRow } from "./accrualImporter.types";

export function useAccrualPreviewNavigation(
    rows: AccrualImporterDocumentRow[],
) {
    const { previewedRowId, setPreviewedRowId } = useContext(
        AccrualImporterContext,
    );

    const previewedIndex = useMemo(
        () =>
            previewedRowId
                ? rows.findIndex((row) => row.id === previewedRowId)
                : -1,
        [rows, previewedRowId],
    );

    const previewSibling = useCallback(
        (offset: number) => {
            const newIndex = previewedIndex + offset;
            if (
                previewedIndex === -1 ||
                newIndex < 0 ||
                newIndex >= rows.length
            ) {
                return;
            }
            setPreviewedRowId(rows[newIndex].id);
        },
        [rows, previewedIndex, setPreviewedRowId],
    );

    const previewNext = useCallback(() => previewSibling(1), [previewSibling]);
    const previewPrevious = useCallback(
        () => previewSibling(-1),
        [previewSibling],
    );

    return {
        previewedIndex,
        totalCount: rows.length,
        previewNext,
        previewPrevious,
    };
}
